/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'feedback-collector.anonymous': 'Questo feedback sarà inviato in forma anonima. Atlassian non potrà contattarti direttamente in merito a questo feedback',
  'feedback-collector.anonymous.title': 'Feedback anonimo',
  'feedback-collector.can-be-contacted.label': "Sì, i team Atlassian possono contattarmi per conoscere le mie esperienze volte a migliorare i prodotti e i servizi Atlassian. Prendo atto dell'<a>Informativa sulla privacy di Atlassian</a>.",
  'feedback-collector.cancel-button.label': 'Annulla',
  'feedback-collector.default.custom.textarea.label': 'A cosa stai pensando?',
  'feedback-collector.enrol-in-research.label': 'Vorrei partecipare alla ricerca sui prodotti',
  'feedback-collector.feedback-title': 'Condividi le tue opinioni',
  'feedback-collector.form.bug.label': 'Descrivi il bug o il problema',
  'feedback-collector.form.comment.label': 'Facci sapere cosa ne pensi',
  'feedback-collector.form.empty.label': "Seleziona un'opzione",
  'feedback-collector.form.question.label': 'Che cosa vorresti sapere?',
  'feedback-collector.form.suggestion.label': 'Facci sapere quale aspetto vorresti fosse migliorato',
  'feedback-collector.option.bug.label': 'Segnalare un bug',
  'feedback-collector.option.comment.label': 'Lasciare un commento',
  'feedback-collector.option.default.label': 'Seleziona il feedback',
  'feedback-collector.option.default.placeholder': 'Scegline uno',
  'feedback-collector.option.question.label': 'Porre una domanda',
  'feedback-collector.option.suggestion.label': 'Suggerire un miglioramento',
  'feedback-collector.required.fields.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
  'feedback-collector.submit-button.label': 'Inviare un feedback',
  'feedback-collector.success-flag.description': 'Il tuo feedback è prezioso e ci aiuta a migliorare continuamente i nostri prodotti.',
  'feedback-collector.success-flag.title': 'Grazie!',
  'feedback-collector.summary-placeholder': 'Facci sapere cosa ne pensi',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Lascia un feedback'
};